An array of codes for the offered schedules for the position.

Currently, two codes are defined:

- `FullTime` indicates a full-time schedule.
- `PartTime` indicates a part-time schedule.

If the offered schedule isn't known this will be `null`.
